import { render, staticRenderFns } from "./Validatable.vue?vue&type=template&id=34cb3f5d&"
import script from "./Validatable.vue?vue&type=script&lang=js&"
export * from "./Validatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports